import { useTranslation } from "react-i18next";
import * as yup from "yup";

const useContributorSchema = () => {
    const { t } = useTranslation();

    return yup.object({
        appleId: yup.string().nullable(),
        name: yup.string().required(t("messages.inputMsgs.required")),
        nameAr: yup.string().required(t("messages.inputMsgs.required")),
    });
};

export default useContributorSchema;
